import { useState, useRef } from "react";
import fyllaVertical from "../photos/fyllaVertical.svg";
import linkArrow from "../photos/linkArrow.svg";
import chevronWhite from "../photos/BiChevronsRightWhite.svg";
import { LANGUAGES, LANGUAGE_LABELS, LANGUAGE_FLAGS } from "../i18n";

const LangRow = ({ label, flag, onClick, cursor }) => (
  <div
    className="container-row-end"
    onClick={onClick}
    style={{ alignItems: "center", cursor }}
  >
    <div
      className="drawer-chip button-text-s"
      style={{ marginRight: "70px", textTransform: "uppercase" }}
    >
      {label}
      <span style={{ fontSize: "22px", lineHeight: 1, fontStyle: "normal" }}>
        {flag}
      </span>
    </div>
  </div>
);

const Menu = ({
  isMenuAnimating,
  containerHeight,
  setLanguage,
  language,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  closeMenu,
  t,
}) => {
  const [pickerOpen, setPickerOpen] = useState(false);
  const [listTop, setListTop] = useState(0);
  const triggerRef = useRef(null);

  const links = [
    { href: "/terms-of-sale", label: "terms-of-sale" },
    { href: "/privacy-policy", label: "privacy-policy" },
    { href: "/terms-of-service", label: "terms-of-service" },
  ];

  const others = LANGUAGES.filter((l) => l.code !== language);

  const openPicker = () => {
    if (triggerRef.current) {
      setListTop(triggerRef.current.getBoundingClientRect().top);
    }
    setPickerOpen(true);
  };

  const selectLang = (code) => {
    setLanguage(code);
    setPickerOpen(false);
  };

  return (
    <div
      className={`menu-container ${isMenuAnimating ? "menu-close" : ""}`}
      style={{ height: containerHeight - 48 }}
    >
      <div className="fylla-vertical-container">
        <img className="fylla-vertical" src={fyllaVertical} alt="" />
      </div>
      <div className="menu-item">
        <div ref={triggerRef}>
          <LangRow
            label={LANGUAGE_LABELS[language] || language}
            flag={LANGUAGE_FLAGS[language]}
            onClick={openPicker}
            cursor="pointer"
          />
        </div>
        <a
          className="drawer-sticker"
          href="https://www.instagram.com/fyl.la_/"
          rel="noopener noreferrer"
          style={{ marginTop: "40px" }}
        >
          <h1
            style={{
              margin: 0,
              fontWeight: 700,
              fontSize: "42px",
              fontStyle: "italic",
            }}
          >
            INSTA
          </h1>
          <img
            style={{
              height: "36px",
              width: "auto",
              filter: "brightness(0)",
            }}
            src={linkArrow}
            alt=""
          />
        </a>
      </div>
      <div
        className="swipe-area"
        style={{ justifyContent: "flex-end" }}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <img
          className="stuttering-arrow-left"
          style={{ paddingRight: "48px" }}
          src={chevronWhite}
          onClick={closeMenu}
          alt=""
        />
      </div>
      <div className="menu-item" style={{ justifyContent: "end" }}>
        {links.map(({ href, label }) => (
          <a
            key={label}
            className="button-tertiary-m button-text-m text-color-white"
            href={href}
            rel="noopener noreferrer"
            style={{
              maxHeight: "32.5px",
            }}
          >
            {t(label)}
          </a>
        ))}
      </div>
      {pickerOpen && (
        <>
          <div
            className="lang-picker-backdrop"
            onClick={() => setPickerOpen(false)}
          />
          <div className="lang-picker-list" style={{ top: listTop }}>
            <LangRow
              label={LANGUAGE_LABELS[language] || language}
              flag={LANGUAGE_FLAGS[language]}
              onClick={() => setPickerOpen(false)}
              cursor="pointer"
            />
            {others.map((l) => (
              <LangRow
                key={l.code}
                label={l.label}
                flag={l.flag}
                onClick={() => selectLang(l.code)}
                cursor="pointer"
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Menu;
